<template>
  <div class="flex-1 flex flex-col">
    <!-- Mobile & Tablet: Progress Bar -->
    <div class="lg:hidden">
      <div class="flex items-center justify-between mb-2">
        <span class="text-xs font-medium text-slate-600 dark:text-slate-400">
          {{ progressText }}
        </span>
      </div>
      <div class="relative h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
        <div
          class="absolute top-0 left-0 h-full bg-hilab dark:bg-hilab-dark rounded-full transition-all duration-500 ease-out"
          :style="{ width: `${progressPercentage || 0}%` }"
        />
      </div>
   
    </div>

    <!-- Desktop: Step Chips (Centered) -->
    <div class="hidden lg:flex items-center justify-center">
      <div class="flex items-center gap-2">
        <div
          v-for="(step, index) in stepItems"
          :key="step.key"
          class="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all"
          :class="chipClass(index)"
        >
          <div class="w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold"
               :class="circleClass(index)">
            <lucide-icon v-if="index < safeCurrentStep" name="check" :size="12" />
            <span v-else>{{ index + 1 }}</span>
          </div>
          <span>{{ step.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LucideIcon from 'dashboard/components/LucideIcon.vue';

export default {
  name: 'AiOnboardingProgressTracker',
  
  components: {
    LucideIcon,
  },

  computed: {
    ...mapState('aiOnboarding', ['currentStep']),
    ...mapGetters('aiOnboarding', ['progressPercentage', 'totalSteps']),

    stepItems() {
      return [
        { key: 'demo', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.DEMO') || 'Giới thiệu' },
        { key: 'profile', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.PROFILE') || 'Hồ sơ' },
        { key: 'modes', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.MODES') || 'Vai trò' },
        { key: 'provider', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.PROVIDER') || 'AI Provider' },
        { key: 'questions', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.QUESTIONS') || 'Câu hỏi' },
        { key: 'generation', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.GENERATION') || 'AI đang học' },
        { key: 'test', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.TEST') || 'Test bot' },
        { key: 'activation', label: this.$t('AI_ONBOARDING.PROGRESS.STEPS.ACTIVATION') || 'Kích hoạt' },
      ];
    },

    progressText() {
      const current = this.currentStep !== undefined && this.currentStep !== null ? this.currentStep : 0;
      const total = this.totalSteps || this.stepItems.length;
      const stepNumber = Math.min(current + 1, total);
      return this.$t('AI_ONBOARDING.PROGRESS.STEP_PROGRESS', { step: stepNumber, total: total }) ||
        `Bước ${stepNumber}/${total}`;
    },
    currentStepItem() {
      const current = this.currentStep !== undefined && this.currentStep !== null ? this.currentStep : 0;
      return this.stepItems[current] || this.stepItems[0] || {};
    },
    safeCurrentStep() {
      return this.currentStep !== undefined && this.currentStep !== null ? this.currentStep : 0;
    },
    safeTotalSteps() {
      return this.totalSteps || this.stepItems.length;
    },
  },

  methods: {
    chipClass(index) {
      const current = this.safeCurrentStep;
      if (index < current) {
        return 'bg-hilab/10 dark:bg-hilab-dark/20 text-hilab dark:text-hilab-dark border border-hilab/30 dark:border-hilab-dark/40';
      }
      if (index === current) {
        return 'bg-hilab dark:bg-hilab-dark text-white shadow-md border border-hilab dark:border-hilab-dark';
      }
      return 'bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-600';
    },
    circleClass(index) {
      const current = this.safeCurrentStep;
      if (index < current) {
        return 'bg-hilab dark:bg-hilab-dark text-white';
      }
      if (index === current) {
        return 'bg-white text-hilab dark:text-hilab-dark';
      }
      return 'bg-slate-200 dark:bg-slate-700 text-slate-500 dark:text-slate-400';
    },
  },
};
</script>
